import { render, staticRenderFns } from "./introduceModel.vue?vue&type=template&id=6ad02ca1&scoped=true&"
import script from "./introduceModel.vue?vue&type=script&lang=js&"
export * from "./introduceModel.vue?vue&type=script&lang=js&"
import style0 from "./introduceModel.vue?vue&type=style&index=0&id=6ad02ca1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad02ca1",
  null
  
)

export default component.exports